.container {
  height: 100%;
  padding: 1.6rem;
}

.description {
  line-height: 2.4rem;
  color: var(--color-texts-low-contrast);
  overflow-wrap: break-word;
  margin-bottom: 2.4rem;

  a {
    color: white;
    text-decoration: underline;
  }
}

.table-wrapper {
  height: 100%;
  overflow-y: auto;
}
